/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gpa_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GPA Calculator`)
};

const es_gpa_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Promedio Académico`)
};

const de_gpa_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notendurchschnitt-Rechner (GPA)`)
};

const nl_gpa_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GPA Calculator`)
};

const fr_gpa_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur de Moyenne (GPA)`)
};

const it_gpa_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore GPA`)
};

const pt_br2_gpa_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de GPA`)
};

const pt_gpa_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Média (GPA)`)
};

const ja_gpa_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GPA計算機`)
};

const zh_gpa_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GPA 计算器`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gpa_tool_name = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gpa_tool_name(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gpa_tool_name", locale)
	if (locale === "en") return en_gpa_tool_name(inputs)
	if (locale === "es") return es_gpa_tool_name(inputs)
	if (locale === "de") return de_gpa_tool_name(inputs)
	if (locale === "nl") return nl_gpa_tool_name(inputs)
	if (locale === "fr") return fr_gpa_tool_name(inputs)
	if (locale === "it") return it_gpa_tool_name(inputs)
	if (locale === "pt-BR") return pt_br2_gpa_tool_name(inputs)
	if (locale === "pt") return pt_gpa_tool_name(inputs)
	if (locale === "ja") return ja_gpa_tool_name(inputs)
	return zh_gpa_tool_name(inputs)
};